export default __webpack_public_path__ + "static/media/This is definitely my greatest strength.a2e46c9d.mp4";